function initTimer(currentElement) {
    if (!currentElement.length) {
        return false;
    }
    let $timer = currentElement.find('.timer');
    let $days = $timer.find('.timer__days');
    let $hours = $timer.find('.timer__hours');
    let $minutes = $timer.find('.timer__minutes');
    let startTime = Date.parse($timer.data('time'));

    let getTime = () => {
        let currentTime = Date.parse(new Date());
        let diffTime = startTime - currentTime;
        let minutes = Math.floor(diffTime / 1000 / 60 % 60);
        let hours = Math.floor(diffTime / (1000 * 60 * 60) % 24);
        let days = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        $days
            .text(`${days} д.`);
        $hours
            .text(`${hours} ч.`);
        $minutes
            .text(`${minutes} м.`);
    };

    getTime();
}

initTimer($('.intro-timer'));
